import { render } from "./App.vue?vue&type=template&id=a8af078e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a8af078e&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__